// @ts-nocheck
import React, { useEffect, useMemo, useRef, useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Table,
  Form,
  notification,
  Input,
  Button,
  Modal,
  DatePicker,
  InputNumber,
  Select,
  Tabs,
  Popconfirm,
  Space,
  Tooltip,
  Row,
  Col,
  Typography,
} from "antd";
import EditableCell from "../../components/EditableCell";
import EditableRow from "../../components/EditableRow";
import AccreditationService from "./../../services/accreditationService";
import { convertStrToDate } from "helper/common";
import {
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { IconCar } from "../../assets/icons";
import "./accreditation.scss";
import moment from "moment";
// import VerifyLicenPlates from '../../constants/licenseplates';
import _ from "lodash";
import { useHistory } from "react-router";
import {
  ListAccreditationKey,
  ListEditAccreditationKey,
  CreateNewCustomerKey,
  AccreditationNotificationKey,
  InspectionProcessKey,
  AccreditationStatisticalKey,
  ListReportStaistic,
  AccreditationSettingKey,
} from "../../constants/accreditationTabs";
import { ModalCrime } from "Page/ListCustomers/ModalCrime";
import { BUTTON_LOADING_TIME } from "constants/time";
import { widthLicensePlate } from "constants/licenseplates";
import TagVehicle from "components/TagVehicle/TagVehicle";
import { getIndexTagVehicleFromColor } from "constants/listSchedule";
import CompletedShowIcon from "components/Completed/CompletedShowIcon";
import UnLock from "components/UnLock/UnLock";
import { validatorPlateNumber } from "helper/licensePlateValidator";
import { validatorPhone } from "helper/commonValidator";
import TagVehicleWarn from "components/TagVehicle/TagVehicleWarn";
import BasicTablePaging from "components/BasicTablePaging/BasicTablePaging";
import { useModalDirectLinkContext } from "components/ModalDirectLink";
import { NORMAL_COLUMN_WIDTH } from "constants/app";
import { VERY_BIG_COLUMN_WIDTH } from "constants/app";
import { BIG_COLUMN_WIDTH } from "constants/app";
import { EXTRA_BIG_COLUMND_WITDTH } from "constants/app";
import BasicButtonPrimary from "components/BasicButtonPrimary";
import FormCreateNewBooking from "./formCreateNewBooking";
import Completed from "components/Completed/Completed";
import AccreditationTabs from "components/AccreditationTabs";
import { MAX_RECORDS_PER_PAGE } from "constants/common";

const { TabPane } = Tabs;

const DEFAULT_FILTER = { filter: {}, skip: 0, limit: MAX_RECORDS_PER_PAGE };

function ListEditAccreditation() {
  const { t: translation } = useTranslation();
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();
  const [isCreate, setIsCreate] = useState(false);
  const [dataAccreditation, setDataAccreditation] = useState({
    total: 0,
    data: [],
  });
  const [crimePlateNumber, setCrimePlateNumber] = useState("");
  const [loading, setLoading] = useState(false);
  // const inputRef = useRef(null)
  const { setUrlForModalDirectLink } = useModalDirectLinkContext();

  const OptionsColor = [
    {
      value: "white",
      lable: (
        <div className="accreditation__parent">
          {translation("accreditation.white")}

          <IconCar className=" accreditation__circle-white" />
        </div>
      ),
    },
    {
      value: "blue",
      lable: (
        <div className="accreditation__parent">
          {translation("accreditation.blue")}

          <IconCar className=" accreditation__circle-blue" />
        </div>
      ),
    },
    {
      value: "red",
      lable: (
        <div className="accreditation__parent">
          {translation("accreditation.red")}

          <IconCar className=" accreditation__circle-red" />
        </div>
      ),
    },
    {
      value: "yellow",
      lable: (
        <div className="accreditation__parent">
          {translation("accreditation.yellow")}

          <IconCar className=" accreditation__circle-yellow" />
        </div>
      ),
    },
  ];
  const [dataFilter, setDataFilter] = useState(DEFAULT_FILTER);
  const [filterValues, setFilterValues] = useState({
  customerRecordCheckDate: convertStrToDate(
    DEFAULT_FILTER.filter?.customerRecordCheckDate,
    "DD/MM/YYYY"
  ),
  customerRecordCheckExpiredDate: convertStrToDate(
    DEFAULT_FILTER.filter?.customerRecordCheckExpiredDate,
    "DD/MM/YYYY"
  ),
});
  const user = useSelector((state) => state.member);
  const history = useHistory();
  const setting = useSelector((state) => state.setting);
  const settingAccreditationTabs = setting.settingAccreditationTabs || "";
  const { message } = useSelector((state) => state.mqtt);
  const topicList = [
    `RECORD_UPDATE_${user.stationsId}`,
    `RECORD_ADD_${user.stationsId}`,
    `RECORD_DELETE_${user.stationsId}`,
  ];

  function handleUpdateNewData(updateData) {
    setDataAccreditation((prevData) => {
      const index = prevData.data.findIndex(
        (item) => item.customerRecordId === updateData.customerRecordId
      );
      if (index !== -1) {
        prevData.data[index] = updateData;
        return {
          total: prevData.total,
          data: [...prevData.data],
        };
      }
    });
  }

  function handleAddNewData(addData) {
    setDataAccreditation((prevData) => {
      const index = prevData.data.findIndex(
        (item) => item.customerRecordId === addData.customerRecordId
      );
      if (index === -1) {
        const newData = [];
        prevData.data.forEach((item) => {
          newData.push({
            ...item,
            isAdd: false,
          });
        });
        if (newData.length > MAX_RECORDS_PER_PAGE) {
          newData.pop();
        }
        return {
          total: prevData.total + 1,
          data: [
            {
              ...addData,
              isAdd: true,
            },
            ...newData,
          ],
        };
      }
    });
  }

  function handleDeleteData(deleteData) {
    setDataAccreditation((prevData) => {
      const newData = prevData.data.filter(
        (item) => item.customerRecordId !== deleteData.customerRecordId
      );
      return {
        total: prevData.total - 1,
        data: newData,
      };
    });
  }

  useEffect(() => {
    if (message) {
      switch (message.topic) {
        case topicList[0]:
          handleUpdateNewData(message);
          break;
        case topicList[1]:
          handleAddNewData(message);
          break;
        case topicList[2]:
          handleDeleteData(message);
          break;
        default:
          break;
      }
    }
  }, [message]);

  function isHiddenTabs(value) {
    if (settingAccreditationTabs.includes(value)) {
      return true;
    }
    return false;
  }

  function handleFetchAccreditation(filter) {
    AccreditationService.getHistory(filter)
      .then((result) => {
        if (result) {
          setDataAccreditation({ ...result });
        }
      })
  }

  async function handleUpdateStatus(record, status) {
    await AccreditationService.updateById({
      id: record.customerRecordId,
      data: {
        customerRecordCheckStatus: status,
      },
    });
    // handleFetchAccreditation(dataFilter)
  }
  function handleUpdateById(data, isReload) {
    AccreditationService.updateById(data).then((result) => {
      if (result) {
        if (result.issSuccess) {
          // form.resetFields()
          isReload && handleFetchAccreditation(dataFilter);
        }
      } else {
        notification["error"]({
          message: "",
          description: translation("accreditation.updateError"),
        });
      }
    });
  }

  function handleDeleteById(data) {
    AccreditationService.deleteById(data).then((result) => {
      if (result && result.issSuccess) {
        notification["success"]({
          message: "",
          description: translation("accreditation.delete_success"),
        });
        handleFetchAccreditation(dataFilter);
      } else {
        notification["error"]({
          message: "",
          description: translation("accreditation.updateError"),
        });
      }
    });
  }

  const handleChangePage = (pageNum) => {
    const newFilter = {
      ...dataFilter,
      skip: (pageNum - 1) * dataFilter.limit,
    };
    setDataFilter(newFilter);
    handleFetchAccreditation(newFilter);
  };

  useEffect(() => {
    isMobileDevice(window.outerWidth);
    handleFetchAccreditation(dataFilter);
  }, []);

  function handleChangeRow(record, currentIndex) {
    dataAccreditation.data[currentIndex - 1] = record;
    setDataAccreditation({ ...dataAccreditation });
  }

  const columns = [
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("listDocumentary.index")}
        </Typography.Paragraph>
      ),
      dataIndex: "stt",
      key: "name",
      width: NORMAL_COLUMN_WIDTH,
      render: (_, __, index) => {
        // return dataFilter.skip ? dataAccreditation.total - (dataFilter.skip + index) : dataAccreditation.total - (index)
        return dataFilter.skip + index + 1;
      },
    },
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("accreditation.licensePlates")}
        </Typography.Paragraph>
      ),
      dataIndex: "customerRecordPlatenumber",
      key: "customerRecordPlatenumber",
      editable: true,
      rules: [
        {
          required: true,
          validator(_, value) {
            return validatorPlateNumber(value, translation);
          },
        },
      ],
      width: BIG_COLUMN_WIDTH,
      render: (_, record) => {
        const {
          customerRecordPlatenumber,
          hasCrime,
          customerRecordPlateColor,
          allCrimesHandled,
          crimesRecords
        } = record;

        return (
          <TagVehicleWarn
            crimesRecords={crimesRecords}
            onClick={() => {
              setCrimePlateNumber(customerRecordPlatenumber);
            }}
          >
            {customerRecordPlatenumber?.toUpperCase()}
          </TagVehicleWarn>
        );
      },
    },
  ];

  const components = {
    body: {
      row: (props) => <EditableRow {...props} form={form} />,
      cell: (props) => <EditableCell {...props} form={form} />,
    },
  };

  // let validateColor = (customerRecordPlatenumber) => {
  //   customerRecordPlatenumber = customerRecordPlatenumber.trim()
  //   let length = customerRecordPlatenumber.length
  //   //get last 2 character
  //   let test = customerRecordPlatenumber[length - 2] + customerRecordPlatenumber[length - 1]
  //   const REAL_LENGTH = 2
  //   let customerRecordPlateColor = OptionsColor[0].value
  //   //validate if user type V / X / T
  //   if(REAL_LENGTH !== parseInt(test).toString().length) {
  //     if(test[1].toUpperCase() === 'X') {
  //       customerRecordPlateColor = OptionsColor[1].value
  //     } else if(test[1].toUpperCase() === 'V') {
  //       customerRecordPlateColor = OptionsColor[2].value
  //     } else {
  //       customerRecordPlateColor = OptionsColor[0].value
  //     }
  //     customerRecordPlatenumber = customerRecordPlatenumber.substring(0, length-1)
  //   } else {
  //     //default not type => T => white
  //     customerRecordPlateColor = OptionsColor[0].value
  //   }

  //   return {
  //     customerRecordPlateColor : customerRecordPlateColor,
  //     customerRecordPlatenumber: customerRecordPlatenumber.toUpperCase()
  //   }
  // }

  function handleSave(row, key, isReload) {
    //   notification.error({
    //     message: '',
    //     description: translation('landing.invalidLicensePlate')
    //   })
    //   return false
    const { customerRecordId } = row;
    // if(key === "customerRecordPlatenumber") {
    //   let renderLP = validateColor(customerRecordPlatenumber)
    //   handleUpdateById({
    //     id: customerRecordId,
    //     data: {
    //       customerRecordPlateColor: renderLP.customerRecordPlateColor,
    //       customerRecordPlatenumber: renderLP.customerRecordPlatenumber
    //     }
    //   })
    //   return true
    // } else {
    let customerRecordCheckExpiredDate = "";
    if (key === "customerRecordCheckDuration") {
      customerRecordCheckExpiredDate = moment(
        row.customerRecordCheckDate,
        "DD/MM/YYYY"
      )
        .add(Number(row.customerRecordCheckDuration), "months")
        .subtract(1, "day")
        .format("DD/MM/YYYY");
      handleUpdateById(
        {
          id: customerRecordId,
          data: {
            [key]: row[key],
            customerRecordCheckExpiredDate: customerRecordCheckExpiredDate,
          },
        },
        isReload
      );
    } else {
      handleUpdateById(
        {
          id: customerRecordId,
          data: {
            [key]: row[key],
          },
        },
        isReload
      );
    }
    // }
  }

  function renderTextOrPlaceholder(
    record,
    dataIndex,
    placeholderTranslationKey
  ) {
    const value = record && record[dataIndex];
    return <div>{value ? value : translation(placeholderTranslationKey)}</div>;
  }

  function renderDatePicker(
    dataIndex,
    placeholderTranslationKey,
    inputRef,
    save,
    setEditing
  ) {
    return (
      <DatePicker
        format="DD/MM/YYYY"
        defaultOpen
        placeholder={translation("accreditation.inspectionExpireDate")}
        ref={inputRef}
        onBlur={() => {
          setEditing(false);
        }}
        onChange={save}
      />
    );
  }

  const columnsV2 = [
    ...columns,
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("accreditation.fullName")}
        </Typography.Paragraph>
      ),
      dataIndex: "customerRecordFullName",
      key: "customerRecordFullName",
      editable: true,
      width: VERY_BIG_COLUMN_WIDTH,
      render: (_, record) =>
        renderTextOrPlaceholder(
          record,
          "customerRecordFullName",
          "accreditation.fullName"
        ),
    },
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("accreditation.phoneNumber")}
        </Typography.Paragraph>
      ),
      dataIndex: "customerRecordPhone",
      key: "customerRecordPhone",
      editable: true,
      width: NORMAL_COLUMN_WIDTH,
      rules: [
        {
          required: true,
          validator(_, value) {
            return validatorPhone(value, translation);
          },
        },
      ],
      render: (_, record) =>
        renderTextOrPlaceholder(
          record,
          "customerRecordPhone",
          "accreditation.phoneNumber"
        ),
    },
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("accreditation.inspectionDate")}
        </Typography.Paragraph>
      ),
      dataIndex: "customerRecordCheckDate",
      key: "customerRecordCheckDate",
      editable: true,
      isTime: true,
      width: BIG_COLUMN_WIDTH,
      componentInput: (inputRef, save, form, setEditing) => {
        return renderDatePicker(
          "customerRecordCheckDate",
          "accreditation.inspectionDate",
          inputRef,
          save,
          setEditing
        );
      },
      render: (_, record) =>
        renderTextOrPlaceholder(
          record,
          "customerRecordCheckDate",
          "accreditation.inspectionDate"
        ),
    },
    {
      title: (
        <Typography.Paragraph className="accreditation__title text-center">
          {translation("accreditation.images")}
        </Typography.Paragraph>
      ),
      dataIndex: "customerRecordImages",
      key: "customerRecordImages",
      width: BIG_COLUMN_WIDTH,
      render: (_, record) => {
        const {
          customerRecordPlateImageUrl,
          customerRecordVehicleImageUrl,
          customerRecordVehicleFrontImageUrl,
        } = record;

        const normalizeUrl = (url) => {
          if (!url) return "";
          return url.startsWith("http") ? url : `https://${url}`;
        };

        const links = [
          {
            label: translation("accreditation.licensePlatesImage"),
            url: normalizeUrl(customerRecordPlateImageUrl),
          },
          {
            label: translation("accreditation.wholeVehicle"),
            url: normalizeUrl(customerRecordVehicleImageUrl),
          },
          {
            label: translation("accreditation.frontVehicle"),
            url: normalizeUrl(customerRecordVehicleFrontImageUrl),
          },
        ];

        return (
          <div className="d-flex flex-column align-items-center">
            {links.map(
              (item, index) =>
                item.url && (
                  <Typography.Link key={index} href={item.url} target="_blank">
                    {item.label}
                  </Typography.Link>
                )
            )}
          </div>
        );
      },
    },
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("accreditation.result")}
        </Typography.Paragraph>
      ),
      dataIndex: "customerRecordCheckStatus",
      key: "customerRecordCheckStatus",
      align: "center",
      width: EXTRA_BIG_COLUMND_WITDTH, // Chiều rộng của cột này đã được tăng lên để nhận phần dư
      componentInput: (inputRef, record) => {
        return <></>;
      },
      render: (value, record) => {
        const { customerRecordCheckStatus } = record;
        return (
          <div className="d-inline-flex">
            {/* <CompletedShowIcon status={value} onClick={(status) => handleUpdateStatus(record, status)} confirm={true} /> */}
            <Completed
              status={value}
              onClick={(status) => handleUpdateStatus(record, status)}
            />
          </div>
        );
      },
    },
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("accreditation.endDate")}
        </Typography.Paragraph>
      ),
      dataIndex: "customerRecordCheckExpiredDate",
      key: "customerRecordCheckExpiredDate",
      editable: true,
      isTime: true,
      width: BIG_COLUMN_WIDTH,
      componentInput: (inputRef, save, form, setEditing) => {
        return renderDatePicker(
          "customerRecordCheckExpiredDate",
          "accreditation.inspectionExpireDate",
          inputRef,
          save,
          setEditing
        );
      },
      render: (_, record) =>
        renderTextOrPlaceholder(
          record,
          "customerRecordCheckExpiredDate",
          "accreditation.inspectionExpireDate"
        ),
    },
    // {
    //   title: <Typography.Paragraph className='accreditation__title'>{translation("accreditation.inspectionCycle")}</Typography.Paragraph>,
    //   dataIndex: 'customerRecordCheckDuration',
    //   key: 'customerRecordCheckDuration',
    //   editable: true,
    //   width: NORMAL_COLUMN_WIDTH,
    //   componentInput: (inputRef, save) => {
    //     return (
    //       <InputNumber
    //         ref={inputRef}
    //         min={0}
    //         max={99}
    //         type="number"
    //         placeholder={translation('inspectionProcess.enterProcessTime')}
    //         onBlur={save}
    //         onPressEnter={save}
    //       />
    //     )
    //   },
    //   render: (_, record) => {
    //     const value = record && record.customerRecordCheckDuration ? (
    //       `${record.customerRecordCheckDuration} ${translation('accreditation.month')}`
    //     ) : translation("accreditation.inspectionCycle")
    //     return <div>{value}</div>
    //   }
    // },
    // {
    //   title: "",
    //   dataIndex: 'Action',
    //   align: "center",
    //   key: 'Action',
    //   // width: NORMAL_COLUMN_WIDTH,
    //   render: (_, record) => {
    //     const { customerRecordId } = record
    //     return (
    //       <Space>
    //         <Popconfirm
    //           title={translation("confirm-delete")}
    //           onConfirm={() => {
    //             handleDeleteById({
    //               id: customerRecordId
    //             })
    //           }}
    //           okText={translation("accreditation.yes")}
    //           cancelText={translation("accreditation.no")}
    //         >
    //           <DeleteOutlined />
    //         </Popconfirm>
    //       </Space>
    //     )
    //   }
    // }
    {
      title: (
        <Typography.Paragraph className="accreditation__title">
          {translation("accreditation.test_content")}
        </Typography.Paragraph>
      ),
      dataIndex: "Action",
      align: "center",
      key: "Action",
      width: BIG_COLUMN_WIDTH,
      render: (_, record) => {
        const { customerRecordId } = record;
        return <></>;
      },
    },
  ];
  const columnsV3 = columnsV2.map((col, index) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        isTime: col.isTime ? true : false,
        componentInput: col.componentInput,
        rules: col.rules,
        handleSave: (row, isReload) => handleSave(row, col.key, isReload),
        handleChangeRow: (record) => handleChangeRow(record, index),
      }),
    };
  });

  const SCHEDULE_ERROR = useMemo(() => {
    return {
      INVALID_STATION: translation(
        "accreditation.scheduleError.invalidStation"
      ),
      INVALID_BOOKING_CONFIG: translation(
        "accreditation.scheduleError.invalidBookingConfig"
      ),
      BOOKING_MAX_LIMITED: translation(
        "accreditation.scheduleError.bookingMaxLimited"
      ),
      UNCONFIRMED_BOOKING_EXISTED: translation(
        "accreditation.scheduleError.unconfirmedBookingExisted"
      ),
    };
  }, [translation]);

  const onCreateNewCustomer = ({ customerRecordPlatenumber }) => {
    // && _verifyCarNumber(customerRecordPlatenumber)
    if (customerRecordPlatenumber) {
      AccreditationService.createNewCustomer({
        customerRecordPlatenumber: customerRecordPlatenumber.toUpperCase(),
        customerStationId: user.stationsId,
        customerRecordCheckDate: moment().format("DD/MM/YYYY"),
        customerRecordPlateColor: OptionsColor[0].value,
      }).then((result) => {
        if (result && result.issSuccess) {
          setIsCreate(false);
          formModal.resetFields();
          // notification['success']({
          //   message: "",
          //   description: translation('accreditation.addSuccess')
          // })
          // handleFetchAccreditation(dataFilter)
        } else {
          if (Object.keys(SCHEDULE_ERROR).includes(result.message)) {
            notification.error({
              message: "",
              description: SCHEDULE_ERROR[result.message],
            });
          } else {
            notification.error({
              message: "",
              description: translation("landing.invalidLicensePlateV2"),
            });
          }
        }
      });
    } else {
      notification.error({
        message: "",
        description: translation("landing.invalidLicensePlate"),
      });
    }
  };

  const onChangeDate = (date, dateString, field) => {
    if (dateString) {
      setFilterValues((prev) => ({ ...prev, [field]: date })); // ✅ lưu moment object để hiển thị
      handleFormChange({ [field]: dateString }); // gửi string cho API/filter
    } else {
      setFilterValues((prev) => ({ ...prev, [field]: null }));
      handleClearFormChange(field);
    }
  };

  const onReloadData = () => {
    setLoading(true);
    setTimeout(() => {
      handleFetchAccreditation(dataFilter);
      setLoading(false);
    }, BUTTON_LOADING_TIME);
    setIsCreate(false);
  };

  const onSearch = (value) => {
    const newFilter = { ...dataFilter };
    if (!value) {
      newFilter.searchText = undefined;
    } else {
      newFilter.searchText = value;
    }
    setDataFilter(newFilter);
    handleFetchAccreditation(newFilter);
  };

  const handleClearFormChange = (field) => {
    const newFilterObj = { ...dataFilter.filter };
    delete newFilterObj[field];
    const newFilter = { ...dataFilter, filter: newFilterObj, skip: 0 };
    setDataFilter(newFilter);
    handleFetchAccreditation(newFilter);
  };

  const handleFormChange = (values) => {
    let newFilter = {
      ...dataFilter,
      filter: { ...dataFilter.filter, ...values },
      skip: 0,
    };
    setDataFilter(newFilter);
    handleFetchAccreditation(newFilter);
  };

  const isMobileDevice = (value) => {
    if (value < 768) {
      dataFilter.limit = 10;
    }
  };

  return (
    <>
      <AccreditationTabs>
        <Fragment>
          <div>
            <Row className="mb-3" gutter={[24, 24]} wrap align="middle" justify="start">
              {/* Search */}
              <Col xl={4} lg={6} md={12} sm={12} xs={24}>
                <Input.Search
                  className="w-100"
                  autoFocus
                  placeholder={translation("listCustomers.search")}
                  onSearch={onSearch}
                />
              </Col>

              {/* Start Date */}
              <Col xl={4} lg={6} md={12} sm={12} xs={24}>
                <DatePicker
                  className="w-100"
                  format="DD/MM/YYYY"
                  placeholder={translation("accreditation.startDate")}
                  value={filterValues.customerRecordCheckDate}
                  onChange={(date, dateString) =>
                    onChangeDate(date, dateString, "customerRecordCheckDate")
                  }
                />
              </Col>

              {/* End Date */}
              <Col xl={4} lg={6} md={12} sm={12} xs={24}>
                <DatePicker
                  className="w-100"
                  format="DD/MM/YYYY"
                  placeholder={translation("accreditation.endDate")}
                  value={filterValues.customerRecordCheckExpiredDate}
                  onChange={(date, dateString) =>
                    onChangeDate(date, dateString, "customerRecordCheckExpiredDate")
                  }
                />
              </Col>

              {/* Buttons: Tạo mới + Refresh */}
              <Col xl={12} lg={6} md={12} sm={24} xs={24} className="d-flex gap-4">
                <BasicButtonPrimary
                  onclick={() => setIsCreate(true)}
                  icon={<PlusOutlined className="addIcon" />}
                  text={translation("inspectionProcess.add")}
                  htmlType="button"
                  className="d-flex justify-content-center align-items-center"
                />
                <Button
                  htmlType="button"
                  type="default"
                  onClick={onReloadData}
                  loading={loading}
                  disabled={loading}
                  icon={<ReloadOutlined />}
                />
              </Col>
            </Row>
            <Table
              rowClassName={(record) =>
                `${
                  record && record.customerRecordModifyDate
                    ? "edited-row editable-row"
                    : "editable-row"
                } ${record && record.isAdd ? "edited-row__add" : ""}`
              }
              dataSource={dataAccreditation?.data || []}
              columns={columnsV3}
              scroll={{ x: 1400 }}
              components={components}
              pagination={false}
            />
            <BasicTablePaging
              handlePaginations={handleChangePage}
              skip={dataFilter.skip}
              count={dataAccreditation?.data?.length < dataFilter.limit}
            ></BasicTablePaging>
            <Modal
              visible={isCreate}
              title={translation("inspectionProcess.add")}
              onCancel={() => setIsCreate(!isCreate)}
              footer={null}
            >
              {/* <Form onFinish={onCreateNewCustomer} form={formModal}>
                <div className="row">
                  <div className="col-12 col-md-12">
                    <Form.Item
                      name="customerRecordPlatenumber"
                    >
                      <Input autoFocus placeholder={translation('landing.license-plates')} />
                    </Form.Item>
                  </div>
                  <div className="col-9 col-md-9" />
                  <div className="col-3 col-md-3 mt-3">
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        {translation('inspectionProcess.save')}
                      </Button>
                      <BasicButtonPrimary
                        htmlType="submit"
                        text={translation('inspectionProcess.save')}
                      />
                    </Form.Item>
                  </div>
                </div>
              </Form> */}
              <FormCreateNewBooking reloadData={onReloadData} />
            </Modal>
          </div>
        </Fragment>
      </AccreditationTabs>

      {!!crimePlateNumber && (
        <ModalCrime
          plateNumber={crimePlateNumber}
          onClose={() => setCrimePlateNumber("")}
        />
      )}
    </>
  );
}
export default ListEditAccreditation;
